import type { AwsMidcIntegration } from "@p0security/integrations-aws-midc-shared/types";
import { installedItems } from "@p0security/shared/install/installed";
import { AppPaths } from "@p0security/shared/routes/constants";

import { TenantAwareLink } from "../../../TenantAwareLink.tsx";
import type { FrontendAws } from "../../types";

export const midcPrerequisiteMessages: (
  context: Readonly<FrontendAws["context"]>
) => Promise<any> = async ({ installed }) => {
  const midcConfig = installed["aws-midc"] as AwsMidcIntegration | undefined;
  if (
    !midcConfig ||
    Object.keys(installedItems("identity", midcConfig)).length === 0
  )
    return (
      <div>
        Requires installed{" "}
        <TenantAwareLink to={`${AppPaths.Integrations}/aws-midc/identity`}>
          AWS Identity Center (merged) identity component
        </TenantAwareLink>
      </div>
    );
};
